import { ReactComponent as IconDiscount } from "../assets/icons/icons-discount.svg";
import CouponCard from "./CouponCard";

export default function CouponSection({ coupons, onToggle, readOnly = false }) {
  if (!coupons || coupons.length === 0) return null;

  return (
    <div className="review-info-card coupon-info-card">
      <div className="review-icon">
        <IconDiscount />
      </div>
      <div className="info-card-content coupon-content">
        <div className="review-heading">Coupons</div>
        <div className="coupon-grid">
          {coupons.map((coupon) => (
            <CouponCard
              key={coupon.code}
              coupon={coupon}
              onToggle={onToggle}
              readOnly={readOnly}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
